module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'select'
	],

	model: {
		potientialValues: {

		},
		potientialValuesKeys: {
			eq: 		'newsletter.segmentsData.operators.eq',
			ne: 		'newsletter.segmentsData.operators.ne',
			lt: 		'newsletter.segmentsData.operators.lt',
			le: 		'newsletter.segmentsData.operators.le',
			gt: 		'newsletter.segmentsData.operators.gt',
			ge: 		'newsletter.segmentsData.operators.ge',
			lk: 		'newsletter.segmentsData.operators.lk',
			nl: 		'newsletter.segmentsData.operators.nl',
			'lk-and': 	'newsletter.segmentsData.operators.lk-and',
			'nl-and': 	'newsletter.segmentsData.operators.nl-and',
			'lk-or': 	'newsletter.segmentsData.operators.lk-or',
			'nl-or': 	'newsletter.segmentsData.operators.nl-or',
		}
	},

	events: {
		change: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var self = event.data.component;
			var $target = $(event.target).closest('select');
			var value = $target.val();

			if(value === '') value = null;
			self.closest('base_form_form', function(form){
				// form.fieldToModel(self.model.fieldCode, value);
				form.childChanged({
					fieldCode: self.model.fieldCode,
					value: value
				});
			});
		}
	},

	methods: {
		onBuild(storage){
			// TODO: POIA: CHECK TRANSLATIONS
			for(const [key, translationKey] of Object.entries(this.model.potientialValuesKeys || {})){
				this.model.potientialValues[key] = storage.__(translationKey)
			}
		},

		dataDealer: function(){
			const storage = this.getStorage()
			this.model['custom-data'] = [
				{
					value: '',
					name: storage.__('newsletter.segmentsData.selectDefaultValues.defaultOperators'),
				}
			];

			for(var operator in this.model.potientialValues){
				this.model['custom-data'].push({
					value: operator,
					name: this.model.potientialValues[operator]
				});
			}
		},

		updateOperators: function(visibleOperators){
			var options = [];
			var actualValue = this.$.val();
			var valueVisible = false;
			for(var operator in visibleOperators || []){
				options.push('option[value="' + visibleOperators[operator] + '"]');
				if(actualValue === visibleOperators[operator]){
					valueVisible = true;
				}
			}
			this.$.find('option[value!=""]').hide();
			this.$.find(options.join(',')).show();
			if(!valueVisible){
				this.$.val('');
				if(actualValue){
					this.triggerClosest('onChildChanged', {
						fieldCode: this.model.fieldCode,
						value: null
					});
				}
			}
		}
	},

	hooks: {
		attach: function(){
			var self = this;
			if(!self.model.segmentationFieldComponent){
				self.closest('templates_newsletter_segments_data_data', function(dataComponent){
					dataComponent.find('templates_newsletter_segments_data_fields_segmentationField', function(fieldComponent){
						self.model.segmentationFieldComponent = fieldComponent;
					});
				});
			}
		},

		segmentationFieldChanged: function($element, options){
			if(this.model.segmentationFieldComponent && options.fieldName){
				this.updateOperators(this.model.segmentationFieldComponent.getFieldDependentOperators(options.fieldName));
			}
		}
	}
};